export default __webpack_public_path__ + "static/media/Paige_Engle.a1d75afa.png";